import { toast } from "react-toastify";
import ErrorUtils from "../../utils/ApiUtils/ErrorUtils";
import { useMutation, useQueryClient } from "react-query";

import ExportTranslationCacheName from "../../utils/ExportTranslationCacheName";
import { deleteTranslation } from "../../api/deleteTranslation";
import { useConfirmDialog } from "../useConfirm";

export function useDeleteTranslation() {
  const queryClient = useQueryClient();
  const confirm = useConfirmDialog();
  return useMutation({
    mutationFn: async (translationId: number) => {
      let result = await deleteTranslation(translationId);
      while (result.confirmationRequired) {
        const count = result.translations.length;
        const approved = await confirm({
          title: count === 1 ? "Delete this translation?" : `Delete ${count} translations?`,
          message:
            (count === 1
              ? "Only the translation below and all its labels will be permanently deleted:\n\n"
              : "The selected translation and its older references listed below will be permanently deleted, along with all their labels:\n\n")
            + result.translations.map((translation) =>
              `Product: ${translation.product} | Maven version: ${translation.mavenVersion} | Target language: ${translation.targetLanguage}`
            ).join("\n")
            + "\n\nThis cannot be undone. Cancel to keep everything unchanged.",
          confirmText: count === 1 ? "Delete translation" : `Delete ${count} translations`,
        });
        if (!approved) return null;
        result = await deleteTranslation(translationId, result.translations.map((translation) => translation.id));
      }
      return result;
    },
    onSuccess: (response) => {
      if (response === null) return;
      toast.success(" The selected translation has been deleted ");
      queryClient.invalidateQueries(ExportTranslationCacheName.getExportTranslation());
    },
    onError: (error) => {
      let errorMsg = ErrorUtils.getErrorMessage(error);
      toast.error(errorMsg);
      console.error("Error submitting form:", error);
    },
  });
}
